import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../../index";
import { api } from "@/lib";
import { ItemTypeResource } from "../../../../models/api/barcodeSystem/itemTypes/get";

const name = "itemType";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class ItemTypeModule extends VuexModule {
  public loading: boolean = false;
  public error: boolean = false;
  public errorMessage: string = "";
  public itemTypes: ItemTypeResource[] = null;

  @Action
  async createItemType(payload) {
    return await api.postAsync("/barcode/itemTypes", payload);
  } 
  
  @Action
  async deleteItemType(itemTypeValue) {
    return await api.deleteAsync(`/barcode/itemTypes/${encodeURIComponent(itemTypeValue)}`);
  }

  @Action
  async getItemTypes() {
    return await api.getAsync("/barcode/itemTypes");
  }

  @Action
  async loadItemTypes(): Promise<void> {
    const response = await this.getItemTypes();
    this.setItemTypes(response.data);
  }

  @Mutation
  setItemTypes(itemTypes: ItemTypeResource[]) {
    this.itemTypes = itemTypes;
  }
}
